import React from 'react';
import ReactDOM from 'react-dom';
import {OverlayLayer} from './LayerInfo/OverLayLayer';
import BaseLayer from './LayerInfo/BaseLayer';
import Layer3DGroup from './LayerInfo/Layer3DGroup';
import TerrainLayer from './LayerInfo/TerrainLayer';
import HelpComponent from './HelpComponent';

class TerrainSiderBar extends React.Component{
    constructor() {
        super();
        this.sidebarChange = this.sidebarChange.bind(this);
        this.state = {
            siderValue:100,
            intervalID:null
        };
    }
    componentDidMount(){
        let siderValue = 100;        
        let componentThis = this;
        var intervalID = setInterval(function() {
            siderValue = window.main.OView.terrainAlpha * 100;            
            componentThis.setState({siderValue:siderValue});
        }, 1000);        
        this.setState({intervalID:intervalID});
    }
    sidebarChange(event){        
        window.main.OView.terrainAlpha = event.target.value/100;
        this.setState({siderValue:event.target.value});
    }
    render(){
        const siderRangeCSS ={
            background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <h4 className="ts eight wide column">地形透視</h4>
                    <label className="ts eight wide column right aligned">{this.state.siderValue + "%"}</label>
                </div>
                
                <div>                    
                    <input type="range" min="0" max="100" value={this.state.siderValue} step="1" onChange={(e)=>this.sidebarChange(e)} style={siderRangeCSS}></input>
                </div>
            </div>
        );
    }
}

class LayerList extends React.Component{
    constructor(){
        super();
        this.setOpenLayer = this.setOpenLayer.bind(this);
        this.deleteLayer = this.deleteLayer.bind(this);
    }    
    setOpenLayer(layer,layerHandelr){
        this.props.setOpenLayer(layer,layerHandelr);
    }
    deleteLayer(layer){
        this.props.deleteLayer(layer);
    }  
    render(){
        const deleteList = this.props.deleteList;
        const LayerLength = this.props.LayerLength;
        return(  
            <div className="ts body siderbar" id="detailsList">
                <TerrainSiderBar />                
                <details className="ts accordion item">
                    <summary>
                        <i className="dropdown icon"></i>
                        地形
                    </summary>
                    <TerrainLayer />
                </details>
                <details className="ts accordion item">
                    <summary>
                        <i className="dropdown icon"></i>
                        底圖
                    </summary>
                    <BaseLayer />
                </details>
                <details className="ts accordion item">
                    <summary>
                        <i className="dropdown icon"></i>
                        2D圖層                        
                    </summary>
                    <OverlayLayer setOpenLayer = {(layer,layerHandel)=>this.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.deleteLayer(layer)} deleteList={deleteList} LayerLength={LayerLength}/>
                </details>
                <details className="ts accordion item">
                    <summary>
                        <i className="dropdown icon"></i>
                        3D圖層
                    </summary>
                    <Layer3DGroup setOpenLayer = {(layer,layerHandel)=>this.setOpenLayer(layer,layerHandel)} deleteLayer = {(layer)=>this.deleteLayer(layer)} deleteList={deleteList}/>
                </details>               
            </div>
        );
    }
}

class LayerListSidebar extends React.Component{
    constructor() {
        super();
        this.sidebarSwitch = this.sidebarSwitch.bind(this);
        this.setOpenLayer = this.setOpenLayer.bind(this);
        this.deleteLayer = this.deleteLayer.bind(this);
        this.state = {
            helpMode : "None"
        }
    }
    sidebarSwitch(){
        this.props.setlayerListOpen();
    }
    setOpenLayer(layer,layerHandelr){
        this.props.setOpenLayer(layer,layerHandelr);
    }
    deleteLayer(layer){
        this.props.deleteLayer(layer);
    }
    onHelpClick(mode){
        this.setState({helpMode : mode});
    }
    render(){
        const islayerListOpen = this.props.islayerListOpen;
        const deleteList = this.props.deleteList;
        const LayerLength = this.props.LayerLength;
        const sideMenuCSS ={
            overflow : 'inherit',
            transform : islayerListOpen?'translate3d(0, 0, 0)':'translate3d(-120%, 0, 0)',
            width : '480px'
        };
        const titleCSS = {
            margin: '10px 10px 10px 10px'
        };
        if(this.state.helpMode === "LayerList"){
            ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/RVYoVDQT6Po" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'))
        }
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));
        }
        return(
            <div>
                <div className="ts left vertical sidebar visible menu" id="sideMenu" style={sideMenuCSS}>
                    <div className="ts grid">
                        <div className="row" id="sideMenuTitle">
                            <div className="twelve wide column">
                                <h4 className="ts header" style={titleCSS}>
                                    <i className="picture icon"></i>
                                    <div className="content">
                                        圖層集
                                    </div>
                                </h4>
                            </div>
                            <div className="two wide column" id="closeIconColumn" style={{alignSelf:"center",textAlign:"right"}}>
                                <button className="ts circular pulsing  icon button" style={{fontSize:"12px",background:"#ccc"}} onClick={(e)=>this.onHelpClick("LayerList")}>
                                    <i className="help small icon" ></i>
                                </button>                    
                            </div>
                            <div className="two wide column" id="closeIconColumn">
                                <i className="remove icon" id="closeIcon" onClick={(e)=>this.sidebarSwitch(e)}></i>                        
                            </div>
                        </div>
                    </div>                    
                    <LayerList setOpenLayer = {(layer,layerHandelr)=>this.setOpenLayer(layer,layerHandelr)} deleteLayer = {(layer)=>this.deleteLayer(layer)} deleteList={deleteList} LayerLength={LayerLength}/> 
                </div>
            </div>            
        );
    }
}

export default LayerListSidebar;